import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const PROJETS = [
  {
    id: 1,
    nom: "EXAMIFY",
    categorie: "Application Web",
    entity: "Technologie",
    entityColor: "#f97316",
    annee: "2024",
    statut: "Livré",
    desc: "Plateforme de gestion d'examens en ligne pour établissements scolaires. Création d'examens, correction automatique, résultats en temps réel et tableau de bord administrateur.",
    tags: ["React", "Node.js", "PostgreSQL", "JWT"],
    icon: "🎓",
    bg: "linear-gradient(135deg, #f97316, #ea580c)",
    resultats: ["500+ étudiants", "20+ établissements", "Zéro fraude"],
  },
  {
    id: 2,
    nom: "GEDIMMO",
    categorie: "Plateforme SaaS",
    entity: "Technologie",
    entityColor: "#f97316",
    annee: "2024",
    statut: "Livré",
    desc: "Logiciel de gestion immobilière complet : suivi des biens, gestion des locataires, quittances automatiques, tableau de bord financier et rapports mensuels.",
    tags: ["React", "Express.js", "MongoDB", "PDF"],
    icon: "🏢",
    bg: "linear-gradient(135deg, #3b6bff, #2d5bdf)",
    resultats: ["200+ biens gérés", "50+ propriétaires", "Gain 80% de temps"],
  },
  {
    id: 3,
    nom: "DASH PRESTATIONS",
    categorie: "Dashboard Admin",
    entity: "Technologie",
    entityColor: "#f97316",
    annee: "2023",
    statut: "Livré",
    desc: "Tableau de bord de gestion pour société de prestations de services : planification des interventions, suivi d'équipes sur le terrain, facturation et reporting.",
    tags: ["React", "Node.js", "Supabase", "Charts.js"],
    icon: "📊",
    bg: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
    resultats: ["30+ techniciens", "150+ interventions/mois", "ROI +45%"],
  },
  {
    id: 4,
    nom: "CODESHOP225",
    categorie: "E-commerce",
    entity: "Technologie",
    entityColor: "#f97316",
    annee: "2024",
    statut: "Livré",
    desc: "Boutique e-commerce spécialisée en équipements informatiques et accessoires. Catalogue produits, panier, paiement mobile money, gestion des commandes et livraisons.",
    tags: ["React", "Node.js", "Cloudinary", "Mobile Money"],
    icon: "🛒",
    bg: "linear-gradient(135deg, #2d9b5c, #16a34a)",
    resultats: ["300+ produits", "1000+ commandes", "3 modes de paiement"],
  },
  {
    id: 5,
    nom: "MAYEDO IMMOBILIER",
    categorie: "Site Vitrine + CRM",
    entity: "Technologie",
    entityColor: "#f97316",
    annee: "2023",
    statut: "Livré",
    desc: "Site vitrine premium pour agence immobilière avec catalogue de biens, système de prise de rendez-vous, espace agent et CRM intégré pour le suivi des prospects.",
    tags: ["React", "Node.js", "PostgreSQL", "Calendly API"],
    icon: "🏠",
    bg: "linear-gradient(135deg, #0ea5e9, #0284c7)",
    resultats: ["500+ visites/mois", "50+ biens listés", "Leads x3"],
  },
  {
    id: 6,
    nom: "BET PORTAIL",
    categorie: "Portail Web",
    entity: "Technologie",
    entityColor: "#f97316",
    annee: "2024",
    statut: "Livré",
    desc: "Portail de paris sportifs en ligne avec gestion des cotes, comptes utilisateurs, transactions sécurisées, historique des mises et interface d'administration complète.",
    tags: ["React", "Express.js", "Redis", "WebSocket"],
    icon: "⚽",
    bg: "linear-gradient(135deg, #dc2626, #b91c1c)",
    resultats: ["2000+ utilisateurs", "Temps réel", "Multi-devise"],
  },
];

const CATS = ["Tous", "Application Web", "Plateforme SaaS", "Dashboard Admin", "E-commerce", "Site Vitrine + CRM", "Portail Web"];

function useInView() {
  const ref = useRef(null);
  const [v, setV] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setV(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, v];
}

export default function Realisations() {
  const [cat, setCat] = useState("Tous");
  const [selected, setSelected] = useState(null);
  const [heroRef, heroV] = useInView();
  const [gridRef, gridV] = useInView();

  const filtered = cat === "Tous" ? PROJETS : PROJETS.filter(p => p.categorie === cat);

  return (
    <div style={{ paddingTop: "72px" }}>

      {/* ─── Hero ─── */}
      <section style={s.hero} ref={heroRef}>
        <div style={s.heroBg} />
        <div className="container" style={{ position: "relative", zIndex: 2, textAlign: "center" }}>
          <div style={{ opacity: heroV ? 1 : 0, transform: heroV ? "translateY(0)" : "translateY(30px)", transition: "all .7s ease" }}>
            <span className="section-tag">Notre portfolio</span>
            <h1 style={s.heroTitle}>Nos <span style={{ color: "#c9a227" }}>réalisations</span></h1>
            <p style={{ fontSize: "17px", color: "rgba(255,255,255,.7)", maxWidth: "580px", margin: "0 auto 32px", lineHeight: 1.8 }}>
              Découvrez les projets que nous avons menés à bien pour nos clients en Côte d'Ivoire.
              Chaque réalisation est une preuve de notre expertise et de notre engagement.
            </p>
            <div style={s.heroStats}>
              {[{ n: "20+", l: "Projets livrés" }, { n: "100%", l: "Clients satisfaits" }, { n: "2022", l: "Depuis" }].map(({ n, l }) => (
                <div key={l} style={s.hStat}>
                  <div style={s.hStatN}>{n}</div>
                  <div style={s.hStatL}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ─── Filtres ─── */}
      <section style={{ background: "#f8f9fc", padding: "40px 0 0" }}>
        <div className="container">
          <div style={s.filters}>
            {CATS.map(c => (
              <button key={c} onClick={() => setCat(c)} style={{ ...s.filter, ...(cat === c ? s.filterActive : {}) }}>
                {c}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ─── Grille projets ─── */}
      <section style={{ background: "#f8f9fc", padding: "40px 0 80px" }} ref={gridRef}>
        <div className="container">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", gap: "28px" }}>
            {filtered.map((p, i) => (
              <div key={p.id} onClick={() => setSelected(p)} style={{
                ...s.card,
                opacity: gridV ? 1 : 0,
                transform: gridV ? "translateY(0)" : "translateY(30px)",
                transition: `all .5s ease ${i * .08}s`,
                cursor: "pointer",
              }}>
                {/* Header coloré */}
                <div style={{ ...s.cardHeader, background: p.bg }}>
                  <div style={s.cardIcon}>{p.icon}</div>
                  <div>
                    <div style={s.cardCat}>{p.categorie}</div>
                    <div style={s.cardNom}>{p.nom}</div>
                  </div>
                  <div style={s.cardAnnee}>{p.annee}</div>
                </div>

                {/* Body */}
                <div style={s.cardBody}>
                  <p style={s.cardDesc}>{p.desc}</p>
                  <div style={s.tags}>
                    {p.tags.map(t => (
                      <span key={t} style={s.tag}>{t}</span>
                    ))}
                  </div>
                  <div style={s.resultats}>
                    {p.resultats.map(r => (
                      <div key={r} style={s.resultat}>
                        <span style={{ color: "#2d9b5c", fontWeight: 700 }}>✓</span> {r}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── Modal détail ─── */}
      {selected && (
        <div style={s.overlay} onClick={() => setSelected(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <button style={s.close} onClick={() => setSelected(null)}>✕</button>
            <div style={{ ...s.modalHeader, background: selected.bg }}>
              <div style={s.cardIcon}>{selected.icon}</div>
              <div>
                <div style={s.cardCat}>{selected.categorie} · {selected.annee}</div>
                <div style={{ ...s.cardNom, fontSize: "24px" }}>{selected.nom}</div>
              </div>
            </div>
            <div style={s.modalBody}>
              <p style={{ fontSize: "15px", color: "#4a5a6a", lineHeight: 1.8, marginBottom: "24px" }}>{selected.desc}</p>
              <div style={{ marginBottom: "20px" }}>
                <div style={s.modalLabel}>Technologies utilisées</div>
                <div style={s.tags}>
                  {selected.tags.map(t => (<span key={t} style={{ ...s.tag, fontSize: "13px", padding: "5px 14px" }}>{t}</span>))}
                </div>
              </div>
              <div style={{ marginBottom: "28px" }}>
                <div style={s.modalLabel}>Résultats obtenus</div>
                {selected.resultats.map(r => (
                  <div key={r} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px", fontSize: "14px", color: "#4a5a6a" }}>
                    <span style={{ color: "#2d9b5c", fontWeight: 700, fontSize: "16px" }}>✓</span>{r}
                  </div>
                ))}
              </div>
              <Link to="/devis" className="btn btn-primary" style={{ justifyContent: "center", width: "100%" }} onClick={() => setSelected(null)}>
                Projet similaire ? Demandez un devis →
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* ─── CTA ─── */}
      <section style={{ background: "linear-gradient(135deg, #0a2540, #1e3a5f)", padding: "70px 0" }}>
        <div className="container text-center">
          <span className="section-tag">Votre projet</span>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "36px", color: "#fff", margin: "16px 0 12px" }}>
            Votre projet sera <span style={{ color: "#c9a227" }}>notre prochaine réalisation</span>
          </h2>
          <p style={{ color: "rgba(255,255,255,.6)", fontSize: "16px", marginBottom: "32px" }}>
            Discutons de votre idée. Devis gratuit et sans engagement sous 24h.
          </p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/devis" className="btn btn-primary" style={{ fontSize: "15px", padding: "14px 32px" }}>Demander un devis</Link>
            <Link to="/contact" className="btn btn-outline" style={{ fontSize: "15px", padding: "14px 32px" }}>Nous contacter</Link>
          </div>
        </div>
      </section>

    </div>
  );
}

const s = {
  hero: { background: "linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%)", padding: "80px 0", position: "relative", overflow: "hidden" },
  heroBg: { position: "absolute", inset: 0, background: "radial-gradient(ellipse at 50% 80%, rgba(201,162,39,.1), transparent 60%)" },
  heroTitle: { fontFamily: "'Playfair Display',serif", fontSize: "clamp(36px,5vw,56px)", fontWeight: 700, color: "#fff", lineHeight: 1.2, margin: "16px 0 20px" },
  heroStats: { display: "flex", gap: "48px", justifyContent: "center", marginTop: "40px" },
  hStat: { textAlign: "center" },
  hStatN: { fontSize: "32px", fontWeight: 900, color: "#c9a227" },
  hStatL: { fontSize: "12px", color: "rgba(255,255,255,.5)", fontWeight: 600, letterSpacing: "1px", textTransform: "uppercase", marginTop: "4px" },
  filters: { display: "flex", gap: "10px", flexWrap: "wrap", paddingBottom: "32px" },
  filter: { padding: "8px 18px", borderRadius: "20px", border: "1.5px solid #d8e0e8", background: "#fff", fontSize: "13px", fontWeight: 600, color: "#4a5a6a", cursor: "pointer", transition: "all .2s" },
  filterActive: { background: "#0a2540", borderColor: "#0a2540", color: "#c9a227" },
  card: { background: "#fff", borderRadius: "16px", border: "1px solid #d8e0e8", overflow: "hidden", boxShadow: "0 4px 20px rgba(10,37,64,.06)", transition: "transform .2s, box-shadow .2s" },
  cardHeader: { padding: "24px 24px 20px", display: "flex", alignItems: "center", gap: "16px", position: "relative" },
  cardIcon: { fontSize: "32px", flexShrink: 0 },
  cardCat: { fontSize: "11px", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", color: "rgba(255,255,255,.7)", marginBottom: "4px" },
  cardNom: { fontSize: "18px", fontWeight: 900, color: "#fff" },
  cardAnnee: { position: "absolute", top: "16px", right: "16px", fontSize: "12px", fontWeight: 700, color: "rgba(255,255,255,.5)", background: "rgba(0,0,0,.15)", padding: "3px 10px", borderRadius: "20px" },
  cardBody: { padding: "20px 24px 24px" },
  cardDesc: { fontSize: "13px", color: "#4a5a6a", lineHeight: 1.7, marginBottom: "14px" },
  tags: { display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "14px" },
  tag: { background: "rgba(10,37,64,.06)", color: "#0a2540", fontSize: "11px", fontWeight: 700, padding: "3px 10px", borderRadius: "20px" },
  resultats: { display: "flex", flexDirection: "column", gap: "4px" },
  resultat: { fontSize: "12px", color: "#4a5a6a", display: "flex", alignItems: "center", gap: "8px" },
  overlay: { position: "fixed", inset: 0, background: "rgba(10,37,64,.7)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" },
  modal: { background: "#fff", borderRadius: "20px", overflow: "hidden", width: "100%", maxWidth: "560px", maxHeight: "90vh", overflowY: "auto", position: "relative" },
  close: { position: "absolute", top: "12px", right: "12px", zIndex: 1, width: "32px", height: "32px", borderRadius: "50%", border: "none", background: "rgba(0,0,0,.3)", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: "14px" },
  modalHeader: { padding: "32px 28px 24px", display: "flex", alignItems: "center", gap: "16px" },
  modalBody: { padding: "24px 28px 28px" },
  modalLabel: { fontSize: "11px", fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", color: "#8a9aaa", marginBottom: "12px" },
};
